module.exports = __webpack_public_path__ + "static/media/agent10.c4578703.png";